import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import DOMPurify from "dompurify";
import api from "@/lib/api";
import { optimizeImageUrl } from "@/lib/imageUtils";
import SEOHead from "@/components/SEOHead";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((res) => setPost(res.data)).catch(() => setPost(null)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="animate-spin text-[var(--brand-primary)]" size={32} /></div>;
  if (!post) return <div className="min-h-[60vh] flex items-center justify-center text-[var(--brand-secondary)]">Post not found.</div>;

  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title,
    "image": post.image || undefined,
    "datePublished": post.created_at,
    "dateModified": post.updated_at || post.created_at,
    "author": { "@type": "Organization", "name": "Gulfudaan" },
    "publisher": { "@type": "Organization", "name": "Gulfudaan" },
    "mainEntityOfPage": window.location.href,
  };

  return (
    <div data-testid="blog-detail-page" className="bg-white py-8 sm:py-24">
      <SEOHead pageKey={post.slug} schema={schema} />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <img src={optimizeImageUrl(post.image, 1000)} alt={post.title} fetchPriority="high" className="w-full h-40 sm:h-72 object-cover rounded-lg mb-4 sm:mb-8" />
        <h1 data-testid="blog-detail-title" className="font-heading text-4xl sm:text-4xl text-[#1A1A1A] mb-3 sm:mb-4">{post.title}</h1>
        <p className="text-xs text-[var(--brand-secondary)] uppercase tracking-wide mb-4 sm:mb-8">{new Date(post.created_at).toLocaleDateString()}</p>
        <div data-testid="blog-detail-content" className="prose text-[var(--brand-secondary)] leading-relaxed" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.content) }} />
      </div>
    </div>
  );
}
